import PurchasesCard from './Purchases.vue';

export default PurchasesCard;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/purchases/index.ts